<template>
<div style="margin-bottom: 100px">
    <vue-headful title="Translations" />

    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <v-row no-gutters>
            <!-- platform filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Platform</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="platform" :items="platforms" item-value="slug" item-text="name" placeholder="Any" clearable @input="filterItems()" :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        hide-details />

                </v-card>
            </v-col>
            <!--./ platform filter-->
            <!-- identifier filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Identifier Prefix</div>
                    <v-text-field class="im-select pa-0 ma-0" flat solo v-model="identifier" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details />
                </v-card>
            </v-col>
            <!--./ identifier filter-->
            <!-- Languages filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Show Languages</div>
                    <v-autocomplete class="im-select pa-0 ma-0" :counter="3" :rules="rules" chips multiple flat solo v-model="selected_languages" :items="languages" item-value="code" item-text="name" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        @input="showLanguages()" hide-details>
                        <template v-slot:selection="data">
                            <v-chip :input-value="data.selected" class="text-uppercase" close small @input="remove(data.item)">
                                {{data.item.code}}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <template>
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize"> {{data.item.name}}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-card>
            </v-col>
            <!--./ Languages filter-->
        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" small rounded depressed class="detail ma-1" :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header-translations :items="tabel_header" @clickEdit="editLanguage($event)" :edit_languages="edit_languages" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-translations-item @input="makeDirty($event, item)" :item="item" :selected_languages="selected_languages" :edit_languages="edit_languages" :is_saved="is_saved" />

                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>

        </v-card>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save_dialog = true">Save changes</v-btn>
        </v-card-actions>
    </v-container>

    <!-- add button -->
    <v-btn color="primary" @click="openCreate()" fab large fixed bottom right>
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->
    <!-- add dialog  -->
    <v-dialog v-model="add_dialog" max-width="920" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card flat tile color="#f5f5f5">
            <v-card-title class="important white--text primary " height="50">Identifier</v-card-title>
            <v-card-text>
                <v-row no-gutters>

                    <v-col cols="12" md="6" class="px-1 py-1">
                        <v-card class="elevation-1 my-1 pa-1">
                            <div class="detail font-weight-bold pa-0 ma-0">Platform</div>
                            <v-select class="im-select pa-0 ma-0" flat solo v-model="item.platform_id" :items="platforms" item-value="id" item-text="name" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                hide-details />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="px-1 py-1">
                        <v-card class="elevation-1 my-1 pa-1">
                            <div class="detail font-weight-bold pa-0 ma-0">Languages</div>
                            <v-autocomplete class="im-select pa-0 ma-0" chips multiple flat solo v-model="identifier_lang" :items="languages" item-value="code" item-text="name" placeholder="Select language" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                hide-details>
                                <template v-slot:selection="data">
                                    <v-chip :selected="data.selected" class="text-uppercase" close small @input="removeFromDialog(data.item)">
                                        {{data.item.code}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-content>
                                            <v-list-item-title class="text-capitalize"> {{data.item.name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-card>
                    </v-col>
                    <v-col cols="12" class="px-1 py-1">
                        <v-card class="elevation-1 my-1 pa-1">
                            <div class="detail font-weight-bold pa-0 ma-0">Identifier</div>
                            <im-search-identifier @input="emitInput" :item.sync="item.identifier" :app_id="item.platform_id" ref="searchIdentifier"></im-search-identifier>
                        </v-card>
                    </v-col>
                    <v-col cols="12" class="px-1 py-1">
                        <v-card class="elevation-1 px-2 py-1">
                            <div class="detail font-weight-bold pa-0 ma-0">Translations</div>
                            <v-row no-gutters class=" im-search translations-card" v-for="(lang, index) in selected_languages" :key="index">
                                <div>
                                    <span>{{ lang }}:</span>
                                </div>
                                <v-col class="px-3">
                                    <im-language-identifier @input="emitInput" :identifier.sync="item.translations[lang.toLowerCase()]" ref="langIdentifier" />
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="exitAddDialog()">Cancel</v-btn>
                <v-btn color="primary" :loading="is_saving" :disabled="is_saving" @click="addItem()">Save &amp; exit</v-btn>
                <v-btn color="primary" :loading="is_saving" :disabled="is_saving" @click="addItemNew()">Save &amp; add new</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./ add dialog  -->

    <!--delete dialog-->
    <v-dialog v-model="save_dialog" max-width="320">
        <v-card>
            <v-card-text class="pt-2">
                Are you sure you want to save?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" @click="save_dialog = false">
                    Cancel
                </v-btn>
                <v-btn color="primary" text @click="saveItems()">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from "../components/utils/PropDefaults.js"
import IMTranslationsItem from '../components/items/TranslationCard.vue'
import IMTableHeaderTranslations from '../components/utils/IMTableHeaderTranslations.vue';
import SearchIdentifier from '../components/utils/SearchIdentifier.vue'
import LanguageIdentifier from '../components/utils/LanguageIdentifier.vue'

export default {

    name: `ratings`,

    components: {
        'im-table-header-translations': IMTableHeaderTranslations,
        'im-translations-item': IMTranslationsItem,
        'im-search-identifier': SearchIdentifier,
        'im-language-identifier': LanguageIdentifier
    },

    data() {
        return {
            is_saved: false,
            is_saving: false,

            save_dialog: false,

            add_dialog: false,
            item: {
                translations: {}
            },
            identifier_lang: ["ro", "en"],

            platforms: [],
            platform: null,
            identifier: null,

            selected_languages: ["ro", "en"],
            edit_languages: [],
            languages: [],

            // search
            search: null,
            search_timeout: 500,
            search_fields: [
                {
                    text: 'Platform',
                    value: 'platforms.name',
                    selected: true
				}, {
                    text: 'Identifier',
                    value: 'identifier',
                    selected: true
				}, {
                    text: 'Translations',
                    value: 'translations',
                    selected: true
				}
			],

            rules: [(v) => v && v.length <= 3 || 'max 3'],
            // table attributes
            items: [],
            loading: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],
        }
    },

    watch: {

        page: {
            handler() {
                this.getItems()
            }
        },
        size: {
            handler() {
                this.getItems()
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500)
            }
        },

        identifier: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500)
            }
        }

    },

    computed: {
        tabel_header: function () {
            let header = [{
                text: "Platform / Identifier",
                edit: false,
                align: "center",
                width: "30%"
			}];
            let col = this.selected_languages.length;
            let width = Math.round(70 / col);
            this.selected_languages.forEach(lang => {
                header.push({
                    text: lang,
                    edit: true,
                    align: "center",
                    width: width + "%"
                })
            });
            return header;
        }
    },
    created() {
        this.getItems();
        this.getPlatforms();
        this.getLanguages();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        emitInput(event) {
            this.$emit('input', event);
        },

        makeDirty(event, item) {
            item[event.language_code] = event.selected_languages;
            item.dirty = true;
        },

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }
            // prepare identifier string
            let identifier = this.identifier;
            if(identifier === "" || identifier === undefined) {
                identifier = null;
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    app_slug: this.platform,
                    search: search,
                    prefix: identifier,
                    fields: fields,
                    page: this.page,
                    size: this.size,
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/identifiers';

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.pagination.total;

                    this.items.forEach(item => {
                        item.dirty = false;
                    })

                    // console.log('dasda', this.items)
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        saveItems() {

            let identifiers = [];

            this.items.forEach(function (item, index) {
                if(item.dirty) {
                    identifiers.push({
                        id: item.id,
                        platform_id: item.platform.id,
                        identifier: item.identifier,
                        translations: item.translations
                    })
                }
            });

            let params = {
                identifiers
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/identifiers/translations';

            // call update or save endpoints
            this.$axios.put(endpoint, params) // eslint-disable-next-line
                .then(response => {
                    this.getItems();
                    this.success('Translations updated.');
                    this.is_saved = true;
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    // this.add_dialog = false;
                    this.is_saving = false;
                    this.save_dialog = false;
                    this.is_saved = false;
                });

        },
        addItem() {
            this.is_saving = false;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/identifiers';

            // call update or save endpoints
            this.$axios.post(endpoint, this.item) // eslint-disable-next-line
                .then(response => {
                    this.getItems();
                    this.success('Identifier created.');
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.exitAddDialog();
                    this.is_saving = false;
                    this.$refs.searchIdentifier.clean();
                    this.$refs.langIdentifier.forEach(function (item) {
                        item.clean();
                    });

                });

        },

        addItemNew() {
            this.is_saving = false;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/identifiers';

            // call update or save endpoints
            this.$axios.post(endpoint, this.item) // eslint-disable-next-line
                .then(response => {
                    this.getItems();
                    this.success('Identifier created.');
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.is_saving = false;
                    this.$refs.searchIdentifier.clean();
                    this.$refs.langIdentifier.forEach(function (item) {
                        item.clean();
                    });
                    this.saveAndAddNew();

                });

        },

        saveAndAddNew() {
            this.item.identifier = null;
            this.identifier_lang.forEach(function (item) {
                this.item.translations[item] = null;
            }.bind(this))
        },

        exitAddDialog() {
            this.item = {
                translations: {}
            };
            this.identifier_lang = ["ro", "en"];
            this.add_dialog = false;
        },

        editLanguage(item) {
            if(item.edit === true) {
                this.edit_languages.push(item.text)
            } else {
                this.edit_languages = this.edit_languages.filter(lang => lang !== item.text);
            }
        },

        languageSelected(value) {
            let item = this.languages.filter(language => language.code === value);
            if(item.length > 0) {
                return item[0].name;
            }
        },

        openCreate() {
            this.add_dialog = true;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        showLanguages() {
            while(this.selected_languages.length > 3) {
                this.selected_languages.splice(-1, 1);
            }
            if(this.selected_languages.length < 4) {
                this.filterItems;
            }
        },

        remove(item) {
            const index = this.selected_languages.indexOf(item.code);
            if(index >= 0) this.selected_languages.splice(index, 1);
            // this.getItems();
        },

        removeFromDialog(item) {
            const index = this.identifier_lang.indexOf(item.code);
            if(index >= 0) this.identifier_lang.splice(index, 1);
            // this.getItems();
        },

        getPlatforms() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/platforms';

            this.$axios.get(endpoint)
                .then(response => {
                    this.platforms = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        getLanguages() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/languages';

            this.$axios.get(endpoint)
                .then(response => {
                    this.languages = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        filterItems() {
            this.page = 1;
            this.getItems();
        },

    }

}
</script>
